import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { Box, Button, Card, Tab, Tabs, Typography } from "@mui/material";

import MainContainer from "../../../layout/MainContainer";
import "../Users.scss";

import {
  ActivityHistory,
  ChallengeHistory,
  Details,
  ProgressHistory,
  PurchaseHistory,
  Review,
  Surveys,
} from "../../../features";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const UserDetails = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState<number>(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">View User Profile</h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate("/manageUsers");
            }}
          >
            Back
          </Button>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            <Box className="flx_sc">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="User Details" {...a11yProps(0)} />
                <Tab label="Activity History" {...a11yProps(1)} />
                <Tab label="Purchase History" {...a11yProps(2)} />
                <Tab label="Progress History" {...a11yProps(3)} />
                <Tab label="Reviews and Ratings" {...a11yProps(4)} />
                <Tab label="Survey History" {...a11yProps(5)} />
                <Tab label="Challenge History" {...a11yProps(6)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Details />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <ActivityHistory />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <PurchaseHistory />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <ProgressHistory />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={4}>
              <Review />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={5}>
              <Surveys />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={6}>
              <ChallengeHistory />
            </CustomTabPanel>
          </Box>
        </Card>
      </div>
    </MainContainer>
  );
};

export default UserDetails;
